// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { negate } from 'lodash/fp';

// Utils
import { hasChanged } from '../../utils/react/propsComparisons';
import { isCommentThread } from '../../../common/elements/utils/elementTypeUtils';
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';

// Components
import ElementDragPreviewPositioner from './ElementDragPreviewPositioner';

// Constants
import { MODIFIER_KEYS } from '../../utils/dnd/modifierKeys/dragModifierKeysConstants';

const dragModifierKeysHaveChanged = hasChanged('dragModifierKeys');

class SelectedElementsDragPreviews extends React.Component {
    shouldComponentUpdate(nextProps) {
        return dragModifierKeysHaveChanged(this.props, nextProps);
    }

    render() {
        const { item, dragModifierKeys } = this.props;
        const { draggedElements } = item;

        const copyDrag = dragModifierKeys.get(MODIFIER_KEYS.altKey);

        const renderedElements = copyDrag ? draggedElements.filter(negate(isCommentThread)) : draggedElements;

        return (
            <div className="SelectedElementsDragPreviews">
                {renderedElements.map((element, index) => {
                    const elementId = getElementId(element);
                    return (
                        <ElementDragPreviewPositioner
                            key={elementId}
                            elementId={elementId}
                            element={element}
                            index={index}
                            {...this.props}
                        />
                    );
                })}
            </div>
        );
    }
}

SelectedElementsDragPreviews.propTypes = {
    item: PropTypes.object.isRequired,
    dragModifierKeys: PropTypes.object,
};

export default SelectedElementsDragPreviews;
